import SliderComponent from './SliderComponent';
export default SliderComponent;
